// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gmActionWrap {
  position: relative;
  display: inline-flex;
}

.gmActionGroup {
  display: inline-flex;
  overflow: hidden;
  border-radius: var(--radius-md, 8px);
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.08);
}

.gmActionButton {
  min-height: 36px;
  padding: 0 14px;
  border: 1px solid transparent;
  font-family: inherit;
  font-size: 13px;
  font-weight: 700;
  line-height: 1;
  cursor: pointer;
}

.gmActionButton--primary {
  border-color: var(--action-primary, #227ebd);
  background: var(--action-primary, #227ebd);
  color: var(--text-on-brand, #fff);
}

.gmActionButton--primary:hover:not(:disabled) {
  border-color: var(--action-primary-hover, #1a6da3);
  background: var(--action-primary-hover, #1a6da3);
  color: #fff;
}

.gmActionButton:disabled {
  cursor: default;
  opacity: 0.5;
}

.gmActionToggle {
  width: 38px;
  padding: 0;
  border-left-color: rgba(255, 255, 255, 0.28);
}

.gmActionDropdown {
  position: absolute;
  z-index: 20;
  top: calc(100% + 6px);
  right: 0;
  display: grid;
  min-width: 180px;
  padding: 6px;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: var(--radius-md, 8px);
  background: var(--surface-card, #fff);
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.16);
}

.gmActionDropdown button {
  padding: 9px 10px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: var(--text-body, #334155);
  font-size: 12.5px;
  font-weight: 650;
  text-align: left;
}

.gmActionDropdown button:hover {
  background: var(--surface-hover, #f1f5f9);
  color: var(--text-strong, #0f172a);
}
`, "",{"version":3,"sources":["webpack://./src/components/GeneralMessageActionsButton/MessageActionsButton.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,oCAAoC;EACpC,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,4CAA4C;EAC5C,0CAA0C;EAC1C,iCAAiC;AACnC;;AAEA;EACE,kDAAkD;EAClD,gDAAgD;EAChD,WAAW;AACb;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,WAAW;EACX,UAAU;EACV,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,QAAQ;EACR,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,+CAA+C;EAC/C,oCAAoC;EACpC,qCAAqC;EACrC,8CAA8C;AAChD;;AAEA;EACE,iBAAiB;EACjB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,kCAAkC;AACpC","sourcesContent":[".gmActionWrap {\n  position: relative;\n  display: inline-flex;\n}\n\n.gmActionGroup {\n  display: inline-flex;\n  overflow: hidden;\n  border-radius: var(--radius-md, 8px);\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.08);\n}\n\n.gmActionButton {\n  min-height: 36px;\n  padding: 0 14px;\n  border: 1px solid transparent;\n  font-family: inherit;\n  font-size: 13px;\n  font-weight: 700;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.gmActionButton--primary {\n  border-color: var(--action-primary, #227ebd);\n  background: var(--action-primary, #227ebd);\n  color: var(--text-on-brand, #fff);\n}\n\n.gmActionButton--primary:hover:not(:disabled) {\n  border-color: var(--action-primary-hover, #1a6da3);\n  background: var(--action-primary-hover, #1a6da3);\n  color: #fff;\n}\n\n.gmActionButton:disabled {\n  cursor: default;\n  opacity: 0.5;\n}\n\n.gmActionToggle {\n  width: 38px;\n  padding: 0;\n  border-left-color: rgba(255, 255, 255, 0.28);\n}\n\n.gmActionDropdown {\n  position: absolute;\n  z-index: 20;\n  top: calc(100% + 6px);\n  right: 0;\n  display: grid;\n  min-width: 180px;\n  padding: 6px;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: var(--radius-md, 8px);\n  background: var(--surface-card, #fff);\n  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.16);\n}\n\n.gmActionDropdown button {\n  padding: 9px 10px;\n  border: 0;\n  border-radius: 6px;\n  background: transparent;\n  color: var(--text-body, #334155);\n  font-size: 12.5px;\n  font-weight: 650;\n  text-align: left;\n}\n\n.gmActionDropdown button:hover {\n  background: var(--surface-hover, #f1f5f9);\n  color: var(--text-strong, #0f172a);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
